import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer class="w-full pt-16 pb-6 text-sm text-center md:text-left fade-in flex justify-between items-center container mx-auto px-6">
      <div class="text-gray-500 no-underline hover:no-underline">
        &copy; Kolyde App 2022
      </div>
      <div class="flex gap-x-4 items-center">
        <Link
          to={"/privacy-policy"}
          class="text-gray-500 no-underline hover:no-underline hover:text-primary transition-colors "
        >
          Cookies Policy
        </Link>
        <Link
          to={"/terms"}
          class="text-gray-500 no-underline hover:no-underline hover:text-primary transition-colors "
        >
          Terms of Use
        </Link>
      </div>
    </footer>
  );
};
